import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(min: Date, max: Date) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || typeof value !== 'string' || value.length !== 10) {
      return null;
    }

    const [day, month, year] = value.split('.').map(Number);
    const parsedDate = new Date(year, month - 1, day);

    if (
      isNaN(parsedDate.getTime()) ||
      parsedDate.getDate() !== day ||
      parsedDate.getMonth() !== month - 1 ||
      parsedDate.getFullYear() !== year
    ) {
      return { invalidDate: true };
    }

    if (parsedDate < min || parsedDate > max) {
      return { dateOutOfRange: true };
    }

    return null;
  };
}
